import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import { joinDateTime } from "@saleor/misc";
import PageheaderCreatePage, {
  PageheaderPageFormData
} from "@saleor/pageheaders/components/PageheaderCreatePage";
import { usePageheaderCreateMutation } from "@saleor/pageheaders/mutations";
import {
  PageheaderAddUrlQueryParams,
  pageheaderListUrl,
  pageheaderUrl
} from "@saleor/pageheaders/urls";
import React from "react";
import { useIntl } from "react-intl";

interface PageheaderDetailsProps {
  params: PageheaderAddUrlQueryParams;
}

const PageheaderDetails: React.FC<PageheaderDetailsProps> = ({}) => {
  const navigate = useNavigator();
  const notify = useNotifier();
  const intl = useIntl();

  const [pageheaderCreate, pageheaderCreateOpts] = usePageheaderCreateMutation({
    onCompleted: data => {
      if (data.pageHeaderCreate.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Successfully created cornermark"
          })
        });
        navigate(pageheaderUrl(data.pageHeaderCreate.pageHeader.id));
      }
    }
  });

  const handleSubmit = async (data: PageheaderPageFormData) => {
    const input = {
      name: data.name,
      isDefault: data.isDefault,
      isTop: data.isTop,
      pcContent: data.pcContent,
      mobileContent: data.mobileContent,
      located: data.located,
      startDate: joinDateTime(data.startDate, data.startTime),
      endDate: joinDateTime(data.endDate, data.endTime),
      countdown: data.countdown,
      pcCountdown: data.pcCountdown,
      mbCountdown: data.mbCountdown,
      languageOpt: data.languageOpt
    };
    const result = await pageheaderCreate({
      variables: {
        input
      }
    });
    return result.data.pageHeaderCreate?.pageHeader?.id || null;
  };
  return (
    <>
      <PageheaderCreatePage
        pageheader={null}
        disabled={pageheaderCreateOpts.loading}
        errors={pageheaderCreateOpts.data?.pageHeaderCreate.errors || []}
        onBack={() => navigate(pageheaderListUrl())}
        onDelete={undefined}
        onSubmit={handleSubmit}
        saveButtonBarState={pageheaderCreateOpts.status}
        title={"add"}
      ></PageheaderCreatePage>
    </>
  );
};

export default PageheaderDetails;
